import type { RouteRecordRaw } from "vue-router";

interface RouteDefinition<R extends RouteRecordRaw = RouteRecordRaw> {
    route: R;
    build?: (...params: any[]) => string;
    debug?: boolean;
}

type MappedRoute<T extends Record<string, RouteDefinition>> = {
    [K in keyof T]: undefined extends T[K]["build"] ? () => string : T[K]["build"];
};

export function defineRoute<const T extends Record<string, RouteDefinition>>(routes: T) {
    const isProduction = import.meta.env.MODE === "production";
    const builders: Partial<MappedRoute<T>> = {};
    const routeRecords: RouteRecordRaw[] = [];

    for (const r of Object.keys(routes)) {
        builders[r as keyof T] = routes[r].build ?? (() => routes[r].route.path);
        if (routes[r].debug === true && isProduction) continue;
        routeRecords.push(routes[r].route);
    }

    return {
        routes: routeRecords,
        to: builders as MappedRoute<T>,
    } as const;
}
